module.exports = __webpack_public_path__ + "media/images/seafood-9fc276f6188fbf6d334b98466a6198da.png";